import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TokenLogo } from "@/components/common/TokenLogo";

export const fmtAmt = (v, d = 6) => (v == null ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: d }));

export const TokenPicker = ({ tokens, value, onChange, testId }) => (
  <Select value={value?.address || ""} onValueChange={(a) => onChange(tokens.find((t) => t.address === a))}>
    <SelectTrigger data-testid={testId} className="w-40 bg-[#0A0A0A] border-[#2A2411] text-white">
      <SelectValue placeholder="Select token" />
    </SelectTrigger>
    <SelectContent className="bg-[#0A0A0A] border-[#2A2411]">
      {tokens.map((t) => (
        <SelectItem key={t.address} value={t.address} data-testid={`${testId}-option-${t.symbol.toLowerCase()}`}>
          <span className="flex items-center gap-2"><TokenLogo symbol={t.symbol} size="sm" />{t.symbol}</span>
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const AmountBox = ({ label, amount, onAmount, token, tokens, onToken, testId, readOnly }) => (
  <div className="p-4 rounded-xl bg-[#050505] border border-[#2A2411]">
    <span className="text-xs text-zinc-500">{label}</span>
    <div className="flex items-center gap-3 mt-2">
      <Input data-testid={`${testId}-amount`} type="number" min="0" placeholder="0.0" value={amount} readOnly={readOnly}
        onChange={(e) => onAmount?.(e.target.value)} className="bg-transparent border-0 text-2xl font-display font-bold text-white p-0 focus-visible:ring-0" />
      <TokenPicker tokens={tokens} value={token} onChange={onToken} testId={`${testId}-token`} />
    </div>
  </div>
);

export const ImportToken = ({ onImport }) => {
  const [addr, setAddr] = useState("");
  return (
    <div className="flex gap-2">
      <Input data-testid="dex-import-input" placeholder="Paste a token contract address (0x…)" value={addr} onChange={(e) => setAddr(e.target.value)}
        className="bg-[#050505] border-[#2A2411] text-white font-mono text-xs" />
      <Button data-testid="dex-import-btn" variant="outline" disabled={!/^0x[0-9a-fA-F]{40}$/.test(addr.trim())}
        onClick={async () => (await onImport(addr)) && setAddr("")} className="border-[#2A2411] text-[#D4AF37] bg-transparent">Import</Button>
    </div>
  );
};

export const ActionBtn = ({ busy, step, disabled, onClick, testId, children }) => (
  <Button data-testid={testId} onClick={onClick} disabled={disabled || busy} className="w-full bg-[#D4AF37] text-black hover:bg-[#F3E5AB] font-semibold h-11">
    {busy ? <span className="flex items-center gap-2"><Loader2 size={16} className="animate-spin" />{step || "Working…"}</span> : children}
  </Button>
);
